import { render, staticRenderFns } from "./ServiceContractTasks.vue?vue&type=template&id=b6bdd7a2"
import script from "./ServiceContractTasks.vue?vue&type=script&lang=js"
export * from "./ServiceContractTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports